/**
 * Complete list of all languages supported by Google Translate
 * Language codes follow ISO 639-1 standard where applicable
 */
export const SUPPORTED_LANGUAGES = {'auto':'Automatic','af':'Afrikaans','sq':'Albanian','am':'Amharic','ar':'Arabic','hy':'Armenian','az':'Azerbaijani','eu':'Basque','be':'Belarusian','bn':'Bengali','bs':'Bosnian','bg':'Bulgarian','ca':'Catalan','ceb':'Cebuano','ny':'Chichewa','zh':'Chinese (Simplified)','zh-CN':'Chinese (Simplified)','zh-TW':'Chinese (Traditional)','co':'Corsican','hr':'Croatian','cs':'Czech','da':'Danish','nl':'Dutch','en':'English','eo':'Esperanto','et':'Estonian','tl':'Filipino','fi':'Finnish','fr':'French','fy':'Frisian','gl':'Galician','ka':'Georgian','de':'German','el':'Greek','gu':'Gujarati','ht':'Haitian Creole','ha':'Hausa','haw':'Hawaiian','iw':'Hebrew','he':'Hebrew','hi':'Hindi','hmn':'Hmong','hu':'Hungarian','is':'Icelandic','ig':'Igbo','id':'Indonesian','ga':'Irish','it':'Italian','ja':'Japanese','jw':'Javanese','kn':'Kannada','kk':'Kazakh','km':'Khmer','ko':'Korean','ku':'Kurdish (Kurmanji)','ky':'Kyrgyz','lo':'Lao','la':'Latin','lv':'Latvian','lt':'Lithuanian','lb':'Luxembourgish','mk':'Macedonian','mg':'Malagasy','ms':'Malay','ml':'Malayalam','mt':'Maltese','mi':'Maori','mr':'Marathi','mn':'Mongolian','my':'Myanmar (Burmese)','ne':'Nepali','no':'Norwegian','ps':'Pashto','fa':'Persian','pl':'Polish','pt':'Portuguese','pa':'Punjabi','ro':'Romanian','ru':'Russian','sm':'Samoan','gd':'Scots Gaelic','sr':'Serbian','st':'Sesotho','sn':'Shona','sd':'Sindhi','si':'Sinhala','sk':'Slovak','sl':'Slovenian','so':'Somali','es':'Spanish','su':'Sundanese','sw':'Swahili','sv':'Swedish','tg':'Tajik','ta':'Tamil','te':'Telugu','th':'Thai','tr':'Turkish','uk':'Ukrainian','ur':'Urdu','uz':'Uzbek','vi':'Vietnamese','cy':'Welsh','xh':'Xhosa','yi':'Yiddish','yo':'Yoruba','zu':'Zulu'};

/**
 * Get language name by code
 * @param {string} code - Language code
 * @returns {string} Language name or code if not found
 */
export function getLanguageName(code) {
 return SUPPORTED_LANGUAGES[code] || code;
}

/**
 * Get all language codes as an array
 * @returns {Array<string>} Array of language codes
 */
export function getAllLanguageCodes() {
 return Object.keys(SUPPORTED_LANGUAGES).filter(code => code !=='auto');
}

/**
 * Get all languages as an array of objects with code and name
 * @returns {Array<{code: string, name: string}>} Array of language objects
 */
export function getAllLanguages() {
 return Object.entries(SUPPORTED_LANGUAGES)
 .filter(([code]) => code !=='auto')
 .map(([code, name]) => ({ code, name }));
}

/**
 * Check if a language code is supported
 * @param {string} code - Language code to check
 * @returns {boolean} True if supported
 */
export function isLanguageSupported(code) {
 return code in SUPPORTED_LANGUAGES;
}

